module.exports = __webpack_public_path__ + "img/DSC_3459.1ce873e9.jpg";